import CartUpsells from './CartUpsells';

export default CartUpsells;
